import { schema } from 'normalizr';

export const noteSchema = new schema.Entity('note');
